import { ControlledTextField, Stack } from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Spacings } from "react-native-ui-lib";
import { CustomerFormValues } from "../../utils/customer";

export function CustomerDetailsForm() {
  const { control } = useFormContext<CustomerFormValues>();

  return (
    <Stack spacing={Spacings.s5} vertical>
      <ControlledTextField
        control={control}
        placeholder="First Name"
        name="firstName"
        filled={false}
        floatingPlaceholder
      />
      <ControlledTextField
        control={control}
        label="Surname"
        placeholder="Surname"
        name="lastName"
        filled={false}
        floatingPlaceholder
      />
      <ControlledTextField
        control={control}
        label="phoneNumber"
        placeholder="Phone Number"
        name="phoneNumber"
        filled={false}
        floatingPlaceholder
      />
      <ControlledTextField
        control={control}
        name="mobileNumber"
        label="Mobile Number"
        placeholder="Mobile Number"
        filled={false}
        floatingPlaceholder
      />
      <ControlledTextField
        control={control}
        name="emailAddress"
        label="Email Address"
        placeholder="Email Address"
        filled={false}
        floatingPlaceholder
      />
    </Stack>
  );
}
